/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import { lazy, useEffect, useState ,Suspense } from "react";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import axios from "axios";
import "@fontsource/poppins";
import "@fontsource/great-vibes";
import "./App.css";

const Body = lazy(() => import("./components/Body"));
const Highlights = lazy(() => import("./components/Highlights"));
const Footer = lazy(() => import("./components/Footer"));
const Navbar =lazy(() => import("./components/Navbar"));

// import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";

function App() {
  
  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const [links, setLinks] = useState([]);
  const appVersion = appversion.version;
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get('https://stagingresources.swmc.com/jsons/ai-branding.json');
        setLinks(response.data);
        console.log(response.data.current)
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };
    fetchLinks();
  }, []);

  return (
    <>
 <CacheBuster
          currentVersion={appVersion}
          isEnabled={true} //If false, the library is disabled.
          isVerboseMode={false} //If true, the library writes verbose logs to console.
          metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
        >
        <Suspense fallback={<div />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<div />}>
        <Body links={links} />
      </Suspense>
      <Suspense fallback={<div />}>
        <Highlights  links={links} />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      </CacheBuster>
    </>
  );
}

export default App;
